import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from "@angular/http";
import { HttpClientModule } from '@angular/common/http';

import { registerLocaleData } from '@angular/common';
import localeJa from '@angular/common/locales/ja';

registerLocaleData(localeJa);

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

import { AuthService } from './Services/auth.service';
import { AuthGuard } from './guard/auth.guard';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { TopComponent } from './top/top.component';
import { CalendarHeadComponent } from './calendar-head/calendar-head.component';
import { PersonalCalendarComponent } from './personal-calendar/personal-calendar.component';
import { AllCalendarComponent } from './all-calendar/all-calendar.component';
import { EventCalendarComponent } from './event-calendar/event-calendar.component';
import { PersonalStatusComponent } from './personal-status/personal-status.component';
import { TeamStatusComponent } from './team-status/team-status.component';
import { AllStatusComponent } from './all-status/all-status.component';
import { WaitReserveComponent } from './wait-reserve/wait-reserve.component';
import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './header/header.component';
import { WorkStepListComponent } from './work-step-list/work-step-list.component';
import { DayReportComponent } from './day-report/day-report.component';
import { SearchConditionComponent } from './search-condition/search-condition.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { CustomerInputComponent } from './customer-input/customer-input.component';
import { MatchingComponent } from './matching/matching.component';
import { MatchingListComponent } from './matching-list/matching-list.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { ConstructScheduleComponent } from './construct-schedule/construct-schedule.component';
import { InputGoalComponent } from './input-goal/input-goal.component';
import { GoalListComponent } from './goal-list/goal-list.component';
import { ReportComponent } from './report/report.component';
import { ReportEditComponent } from './report-edit/report-edit.component';
import { ReportListComponent } from './report-list/report-list.component';
import { CompanyRelatedComponent } from './company-related/company-related.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserRegisterComponent } from './user-register/user-register.component';
import { ItemsSettingComponent } from './items-setting/items-setting.component';
import { SearchTopComponent } from './search-top/search-top.component';
import { RegisterPasswordComponent } from './register-password/register-password.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { AdminMenuComponent } from './admin-menu/admin-menu.component';
import { DayReportListComponent } from './day-report-list/day-report-list.component';
import { DayReportEditComponent } from './day-report-edit/day-report-edit.component';
import { PersonalTargetComponent } from './personal-target/personal-target.component';
import { DivisionTargetComponent } from './division-target/division-target.component';
import { AllTargetComponent } from './all-target/all-target.component';
import { LostAnalysisComponent } from './lost-analysis/lost-analysis.component';
import { SummaryComponent } from './summary/summary.component';
import { ContractListComponent } from './contract-list/contract-list.component';
import { PostionViewComponent } from './postion-view/postion-view.component';
import { PostionEditComponent } from './postion-edit/postion-edit.component';
import { EnqueteComponent } from './enquete/enquete.component';
import { DynamicFormQuestionComponent } from './enquete/dynamic-form-question.component';
import { EnqueteSettingComponent } from './enquete-setting/enquete-setting.component';
import { MyModalConfirmContent } from './Services/modal-service.service';
import { MyModalMessageContent } from './Services/modal-service.service';
import { WebRequestComponent } from './web-request/web-request.component';
import { BusinessOperatorComponent } from './business-operator/business-operator.component';
import { PostingComponent } from './posting/posting.component';
import { PlaceComponent } from './place/place.component';
import { InterviewListComponent } from './interview-list/interview-list.component';

library.add(fas, far);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TopComponent,
    CalendarHeadComponent,
    PersonalCalendarComponent,
    AllCalendarComponent,
    EventCalendarComponent,
    PersonalStatusComponent,
    TeamStatusComponent,
    AllStatusComponent,
    WaitReserveComponent,
    HeaderComponent,
    WorkStepListComponent,
    DayReportComponent,
    SearchConditionComponent,
    SearchResultComponent,
    CustomerInputComponent,
    MatchingComponent,
    MatchingListComponent,
    CustomerListComponent,
    ConstructScheduleComponent,
    InputGoalComponent,
    GoalListComponent,
    ReportComponent,
    ReportEditComponent,
    ReportListComponent,
    CompanyRelatedComponent,
    UserManagementComponent,
    UserRegisterComponent,
    ItemsSettingComponent,
    SearchTopComponent,
    RegisterPasswordComponent,
    CustomerDetailComponent,
    AdminMenuComponent,
    DayReportListComponent,
    DayReportEditComponent,
    PersonalTargetComponent,
    DivisionTargetComponent,
    AllTargetComponent,
    LostAnalysisComponent,
    SummaryComponent,
    ContractListComponent,
    PostionViewComponent,
    PostionEditComponent,
    EnqueteComponent,
    DynamicFormQuestionComponent,
    EnqueteSettingComponent,
    MyModalConfirmContent,
    MyModalMessageContent,
    WebRequestComponent,
    BusinessOperatorComponent,
    PostingComponent,
    PlaceComponent,
    InterviewListComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    NgbModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    HttpModule,
    HttpClientModule,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'ja',

    },
    AuthGuard,
    AuthService
  ],
  entryComponents: [
    MyModalConfirmContent,
    MyModalMessageContent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
